export default "__VITE_ASSET__CYoBkPxt__"